export type CommentSort = "newest" | "oldest"

export const COMMENT_SORT_STORAGE_KEY = "moderniser_comment_sort"

// Newest first unless the reader chose otherwise: on a long thread the latest
// note is the one they came for.
export function commentSortFromStored(value: string | null | undefined): CommentSort {
  return value === "oldest" ? "oldest" : "newest"
}

export function readCommentSort(): CommentSort {
  try {
    return commentSortFromStored(localStorage.getItem(COMMENT_SORT_STORAGE_KEY))
  } catch {
    return "newest"
  }
}

export function saveCommentSort(sort: CommentSort): void {
  try {
    localStorage.setItem(COMMENT_SORT_STORAGE_KEY, sort)
  } catch {
    // The setting still works for this page when storage is unavailable.
  }
}

/** The API answers oldest first; this reorders a copy for display. Comments
 *  posted in the same millisecond keep the server's order in both directions,
 *  so flipping the toggle twice never shuffles them. */
export function sortComments<T extends { createdAt: string }>(comments: T[], sort: CommentSort): T[] {
  const direction = sort === "newest" ? -1 : 1
  return comments
    .map((comment, index) => ({ comment, index, at: Date.parse(comment.createdAt) }))
    .sort((a, b) => (a.at - b.at) * direction || a.index - b.index)
    .map(({ comment }) => comment)
}
